import client from '../services/client';

export const getAutoPartnerPaymentUrl = async ({
  invoiceId,
}: {
  invoiceId: string;
}) => {
  const response = await client.getAutoPartnerPaymentUrl({
    invoiceId,
  });

  return response.data.data.payment_link;
};
